/* eslint-disable no-unused-vars */
import {API_URL, itemPerPage} from '../constants/index.js';
import {
    HELP_TILES,
    HELP_TILES_SUCCESS,
    HELP_TILES_ERROR,
    ADD_HELP_TILES,
    ADD_HELP_TILES_SUCCESS,
    ADD_HELP_TILES_ERROR,
    UPD_HELP_TILES,
    UPD_HELP_TILES_SUCCESS,
    UPD_HELP_TILES_ERROR,
    DEL_HELP_TILES,
    DEL_HELP_TILES_ERROR,
    DEL_HELP_TILES_SUCCESS
} from '../constants/helpTilesConstants';

import {sweetAlert} from '../components/Alert/sweetAlert'


//#region help_tiles (ALL - BYID)
export function gethelpTiles(data) {
    return {
        type: HELP_TILES,
        data
    }
}

export function gethelpTilesSuccess(data) {
    return {
        type: HELP_TILES_SUCCESS,
        data
    }
}

export function gethelpTilesError(data) {
    return {
        type: HELP_TILES_ERROR,
        data
    }
}

export function getAllhelpTiles(currentPage) {
    return dispatch => {
        dispatch(gethelpTiles());
        fetch(API_URL+`cms/helptiles/helptiles?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                 }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(gethelpTilesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(gethelpTilesError(error));
            })
    }
}

export function gethelpTileById(id) {
    return dispatch => {
        dispatch(gethelpTiles());
        fetch(API_URL+'helptiles/helptiles/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                 }
            })
            .then(res => res.json())
            .then(res => {
                if(res.ok)
                    dispatch(gethelpTilesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(gethelpTilesError(error));
            })
    }
}

//#endregion


//#region ADD HELP_TILES

    export function newhelpTile(data) {
        return {
            type: ADD_HELP_TILES,
            data
        }
    }

    export function newhelpTileSuccess(data) {
        return {
            type: ADD_HELP_TILES_SUCCESS,
            data
        }
    }

    export function newhelpTileError(data) {
        return {
            type: ADD_HELP_TILES_ERROR,
            data
        }
    }

    export function addHelpTile(data) {
        return dispatch => {
            dispatch(newhelpTile());
            fetch(API_URL+'helptiles/helptiles',
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                     }
                })
                .then(res => res.json())
                .then(res => {
                    dispatch(newhelpTileSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The video ${data.id} has been added successfully`

                    sweetAlert('success',message,'alert_Add_Help_Tile_Success');
                })
                .catch(error => {
                    dispatch(newhelpTileError(error));
                    const message = `An error occurred trying to add the help tile ${data.id} `

                    sweetAlert('error',message,'alert_Add_Help_Tile_Error');
                })
        }
    }


//#endregion

//#region UPDATE HELP_TILES

    export function modhelp_Tile(data) {
        return {
            type: UPD_HELP_TILES,
            data
        }
    }

    export function modhelp_TileSuccess(data) {
        return {
            type: UPD_HELP_TILES_SUCCESS,
            data
        }
    }

    export function modhelp_TileError(data) {
        return {
            type: UPD_HELP_TILES_ERROR,
            data
        }
    }

    export function updHelpTile(id, data) {
        return dispatch => {
            dispatch(modhelp_Tile());
            fetch(API_URL+'modhelp_Tile/'+ id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                     }
                })
                .then(res => {
                    dispatch(modhelp_TileSuccess(data));

                    return res;
                })
                .then( () =>{

                    const message = `The element ${data.id} has been updated successfully`

                    sweetAlert('success',message,'alert_UpdateHelp_Tile_Success');
                })
                .catch(error => {
                    dispatch(modhelp_TileError(error));

                    const message = `An error occurred when trying to update the help tile: ${data.id} `

                    sweetAlert('error',message,'alert_UpdateHelp_Tile_Error');
                })
        }
    }

//#endregion


//#region DELETE HELP_TILES

export function deletehelp_Tile(data) {
    return {
        type: DEL_HELP_TILES,
        data
    }
}

export function deletehelp_TileSuccess(data) {
  
    return {
        type: DEL_HELP_TILES_SUCCESS,
        data
    }
}

export function deletehelp_TileError(data) {
    return {
        type: DEL_HELP_TILES_ERROR,
        data
    }
}

export function delHelp_Tile(id) {
    return dispatch => {
        
        dispatch(deletehelp_Tile());
        
        fetch(API_URL+'helptiles/helptiles/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deletehelp_TileSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The video has been deleted successfully`

                sweetAlert('success',message,'alert_Delete_Help_Tiles_Success');
            })
            .catch(error => {
                dispatch(deletehelp_TileError(error));

                const message = `An error occurred trying to delete the help tile `

                sweetAlert('error',message,'alert_Delete_Help_Tiles_Error');
            })
    }
}

//#endregion
